(function() {
  'use strict';

  function initAgeGate() {
    if (sessionStorage.getItem('age_verified') === '1') return;
    const gate = document.getElementById('age-gate');
    if (!gate) return;
    gate.classList.add('show');
    document.body.style.overflow = 'hidden';
    const yes = gate.querySelector('[data-age-yes]');
    const no = gate.querySelector('[data-age-no]');
    if (yes) yes.addEventListener('click', function() {
      sessionStorage.setItem('age_verified', '1');
      gate.classList.remove('show');
      document.body.style.overflow = '';
    });
    if (no) no.addEventListener('click', function() { window.location.href = 'https://www.google.com'; });
  }

  function openCart() {
    const drawer = document.getElementById('cart-drawer');
    const bg = document.getElementById('cart-drawer-bg');
    if (!drawer) return;
    drawer.classList.add('open');
    if (bg) bg.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    const drawer = document.getElementById('cart-drawer');
    const bg = document.getElementById('cart-drawer-bg');
    if (!drawer) return;
    drawer.classList.remove('open');
    if (bg) bg.classList.remove('open');
    document.body.style.overflow = '';
  }
  function initCartDrawer() {
    document.querySelectorAll('[data-cart-open]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        refreshCartDrawer();
        openCart();
      });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function(el) {
      el.addEventListener('click', closeCart);
    });
  }

  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function refreshCartDrawer() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); updateCartCount(cart.item_count); })
      .catch(function() {});
  }

  function renderCartDrawer(cart) {
    const body = document.querySelector('#cart-drawer .cart-drawer-body');
    const footer = document.querySelector('#cart-drawer .cart-drawer-footer');
    if (!body || !footer) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a href="/collections/all" class="btn-primary">Shop the Humidor</a></div>';
      footer.innerHTML = '';
      return;
    }
    let html = '<ul class="cart-items">';
    cart.items.forEach(function(item) {
      const img = item.featured_image ? item.featured_image.url : '';
      html += '<li class="cart-item" data-key="' + item.key + '">';
      html += '<div class="cart-item-img">' + (img ? '<img src="' + img + '" alt="' + item.title + '">' : '') + '</div>';
      html += '<div><div class="cart-item-title">' + item.product_title + '</div>';
      if (item.variant_title) html += '<div class="cart-item-variant">' + item.variant_title + '</div>';
      html += '<div class="cart-item-actions"><div class="qty-selector">';
      html += '<button type="button" data-qty-change="-1">−</button>';
      html += '<input type="number" value="' + item.quantity + '" readonly>';
      html += '<button type="button" data-qty-change="1">+</button>';
      html += '</div>';
      html += '<span class="cart-item-remove" data-cart-remove>Remove</span>';
      html += '</div></div>';
      html += '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;

    const threshold = 15000;
    const progress = Math.min(100, (cart.total_price / threshold) * 100);
    const remaining = Math.max(0, threshold - cart.total_price);
    let progressHtml = '';
    if (remaining > 0) {
      progressHtml = '<div class="shipping-progress"><p>Add <strong>' + formatMoney(remaining) + '</strong> for free shipping</p><div class="shipping-bar"><div class="shipping-bar-fill" style="width:' + progress + '%"></div></div></div>';
    } else {
      progressHtml = '<div class="shipping-progress"><p><strong>✓ You\'ve unlocked free shipping</strong></p></div>';
    }
    footer.innerHTML =
      '<div class="cart-summary-row"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      progressHtml +
      '<a href="/checkout" class="btn-primary btn-block" style="margin-top:16px;">Checkout</a>' +
      '<a href="/cart" class="btn-outline" style="margin-top:8px; display:block;">View Bag</a>';

    body.querySelectorAll('[data-qty-change]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const item = btn.closest('.cart-item');
        const key = item.dataset.key;
        const change = parseInt(btn.dataset.qtyChange, 10);
        const input = item.querySelector('input');
        const newQty = Math.max(0, parseInt(input.value, 10) + change);
        updateCartItem(key, newQty);
      });
    });
    body.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const key = btn.closest('.cart-item').dataset.key;
        updateCartItem(key, 0);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); updateCartCount(cart.item_count); });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
    });
  }

  function initAddToCart() {
    document.querySelectorAll('[data-quick-add]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.dataset.quickAdd;
        if (!variantId) return;
        const original = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          btn.textContent = 'Added ✓';
          setTimeout(function() { btn.textContent = original; btn.disabled = false; }, 1200);
          refreshCartDrawer();
          openCart();
        })
        .catch(function() { btn.textContent = original; btn.disabled = false; });
      });
    });

    const form = document.querySelector('form[data-product-form]');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const formData = new FormData(form);
        const submitBtn = form.querySelector('[type="submit"]');
        const original = submitBtn.textContent;
        submitBtn.textContent = 'Adding...';
        submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          submitBtn.textContent = 'Added ✓';
          refreshCartDrawer();
          openCart();
          setTimeout(function() { submitBtn.textContent = original; submitBtn.disabled = false; }, 1500);
        });
      });
    }

    document.querySelectorAll('[data-qty-stepper]').forEach(function(stepper) {
      const input = stepper.querySelector('input');
      stepper.querySelectorAll('button').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const change = parseInt(btn.dataset.qtyStep, 10);
          const newVal = Math.max(1, parseInt(input.value, 10) + change);
          input.value = newVal;
        });
      });
    });
  }

  function initProductGallery() {
    const thumbs = document.querySelectorAll('[data-gallery-thumb]');
    const main = document.querySelector('[data-gallery-main] img');
    if (!main) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        const src = thumb.dataset.src;
        if (src) main.src = src;
      });
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function(group) {
      const buttons = group.querySelectorAll('[data-tab]');
      const contents = group.querySelectorAll('[data-tab-content]');
      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          const target = btn.dataset.tab;
          buttons.forEach(function(b) { b.classList.remove('active'); });
          contents.forEach(function(c) { c.style.display = 'none'; });
          btn.classList.add('active');
          const content = group.querySelector('[data-tab-content="' + target + '"]');
          if (content) content.style.display = 'block';
        });
      });
    });
  }

  function initNewsletter() {
    document.querySelectorAll('.newsletter').forEach(function(form) {
      form.addEventListener('submit', function() {
        const btn = form.querySelector('button');
        if (btn) setTimeout(function() { btn.textContent = 'Sent ✓'; }, 100);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAgeGate();
    initCartDrawer();
    initAddToCart();
    initProductGallery();
    initTabs();
    initNewsletter();
  });
})();
